import { Navigate, Route, Routes } from "react-router-dom";

import RequireAuth from "./auth/RequireAuth.jsx";
import DashboardLayout from "./pages/dashboard/Layout.jsx";
import Home from "./pages/dashboard/Home.jsx";
import Websites from "./pages/dashboard/Websites.jsx";
import Prompts from "./pages/dashboard/Prompts.jsx";
import PromptVolume from "./pages/dashboard/PromptVolume.jsx";
import Schedule from "./pages/dashboard/Schedule.jsx";
import Answers from "./pages/dashboard/Answers.jsx";
import Sources from "./pages/dashboard/Sources.jsx";
import Competitors from "./pages/dashboard/Competitors.jsx";
import Billing from "./pages/dashboard/Billing.jsx";
import Account from "./pages/dashboard/Account.jsx";
import GA4Integration from "./pages/dashboard/GA4Integration.jsx";
import LlmsTxt from "./pages/dashboard/LlmsTxt.jsx";
import Landing from "./pages/Landing.jsx";
import Login from "./pages/Login.jsx";
import Offer from "./pages/legal/Offer.jsx";
import Privacy from "./pages/legal/Privacy.jsx";
import Register from "./pages/Register.jsx";
import ResetPassword from "./pages/ResetPassword.jsx";
import Terms from "./pages/legal/Terms.jsx";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      {/* Phase 6 — public legal pages. Linked from the footer of
          both the marketing landing and the dashboard sidebar. */}
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/offer" element={<Offer />} />

      <Route
        path="/dashboard"
        element={
          <RequireAuth>
            <DashboardLayout />
          </RequireAuth>
        }
      >
        <Route index element={<Home />} />
        <Route path="websites" element={<Websites />} />
        <Route path="websites/:websiteId/prompts" element={<Prompts />} />
        <Route path="websites/:websiteId/llms-txt" element={<LlmsTxt />} />
        <Route path="websites/:websiteId/schedule" element={<Schedule />} />
        <Route path="websites/:websiteId/answers" element={<Answers />} />
        <Route path="websites/:websiteId/sources" element={<Sources />} />
        <Route path="websites/:websiteId/competitors" element={<Competitors />} />
        <Route
          path="websites/:websiteId/integrations/ga4"
          element={<GA4Integration />}
        />
        {/* Public shorthand the OAuth callback redirects to (no websiteId
            in the URL — the page reads ?website_id=… from the query). */}
        <Route path="integrations/ga4" element={<GA4Integration />} />
        <Route path="prompt-volume" element={<PromptVolume />} />
        <Route path="billing" element={<Billing />} />
        <Route path="account" element={<Account />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
